<template>
	<div class="c-body">
		<div class="c-body__title">
			<h2>更新履歴</h2>
		</div>
		<div class="c-body__inner">
			<div class="e-section">
				<div class="c-history-list">
					<ul class="c-history-list__list">
						<li class="c-history-list__item" v-for="item in history">
							<span class="date">{{item.date}}</span>
							<span class="content" v-html="item.content"></span>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import mCommon from "../mixins/common";
import history from "../json/history.js";
import apps from "../json/apps.js";


export default {
	mixins: [
		mCommon
	],
	data(){
		return {
			history: []
		}
	},
	created (){
		this.history = history.history.map((item) => {
			item.content = this.genContent(item.content);
			return item;
		})
	},
	methods: {
		genContent (str){
			str = (Array.isArray(str)) ? str.join("<br>") : str;
			str = str.replace(/\{\{(\w+?)\}\}/g, (a, name) => {
				var path = null;
				apps.map((app) => {
					if(app.name === name){
						path = app.path;
					}
				});
				if(path){
					return `<a href="${path}">${name}</a>`;
				}
				return `<del>${name}</del>`;
			});
			return str;
		}
	}
}
	
</script>



// WEBPACK FOOTER //
// history.vue?3d48b744